import type { CryptoCurrency, CryptoSaleStatus, InstallmentStatus } from './types';

export const CRYPTO_CURRENCIES: CryptoCurrency[] = ['USDT', 'USDC', 'USD'];

/** O mesmo limite do servidor: dois meses de saques diários. */
export const MAX_INSTALLMENTS = 60;

const amountFormat = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** "2.500,00 USDT" · "US$ 2.500,00" */
export function formatCrypto(cents: number, currency: CryptoCurrency): string {
  const value = amountFormat.format((cents || 0) / 100);
  return currency === 'USD' ? `US$ ${value}` : `${value} ${currency}`;
}

export const SALE_STATUS_LABELS: Record<CryptoSaleStatus, string> = {
  ACTIVE: 'Pagando',
  DONE: 'Paga',
  INTERRUPTED: 'Interrompida',
};

export const INSTALLMENT_STATUS_LABELS: Record<InstallmentStatus, string> = {
  PAID: 'Paga',
  CANCELED: 'Cancelada',
  OVERDUE: 'Atrasada',
  TODAY: 'Vence hoje',
  UPCOMING: 'A vencer',
};

/** A mesma divisão do servidor: parcelas iguais, a última leva o arredondamento. */
export function splitEvenly(total: number, count: number): number[] {
  if (count < 1) return [];
  const base = Math.floor(total / count);
  return Array.from({ length: count }, (_, index) => (index === count - 1 ? total - base * (count - 1) : base));
}

/** "2026-10-02" + 3 dias → "2026-10-05", sem passar por fuso. */
export function addDaysISO(date: string, days: number): string {
  const [year, month, day] = date.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
}

/** Quantas parcelas cabem no limite de saque por dia (centavos na moeda). */
export const installmentsForLimit = (total: number, dailyLimit: number): number =>
  dailyLimit > 0 ? Math.min(MAX_INSTALLMENTS, Math.max(1, Math.ceil(total / dailyLimit))) : 1;

/** Real recebido a partir da cotação (R$ por 1 unidade da moeda). */
export const brlFromRate = (amountCents: number, rate: number): number => Math.round((amountCents / 100) * rate * 100);
